import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import API from "../../Common/Endpoint/serviceConstrants";
import axiosInstance from "../../Common/Axios/axiosInstance";

export const getclientConfigDataAsync = createAsyncThunk('getclientConfigDataAsync', async (payload) => {
    try {
        const { data = {} } = await axiosInstance.get(`${API.clientMasterConfigData}`, {
            params: {
                configKey: payload,
            },
            headers: {
                ...axiosInstance.defaults.headers,
                Encryption: 1,
            }
        },
        );
        return data;
    } catch (error) {
        throw new Error('Get config data fail');
    }
});

export const clientConfigDataSlice = createSlice({
    name: "client-config-data",
    initialState: {
        isLoading: false,
        isError: false,
        clientConfigData: [],
        message: "",
        isgetLoading: true,
    },
    reducers: {
        passwordModalChecked: (state) => {
            return {
                ...state,
                passwordChecked: true,
                message: "",
            };
        },
        passwordModalReset: (state) => {
            return {
                ...state,
                passwordChecked: false,
                message: "",
            };
        },
        onGetClientConfigData: (state) => {
            return {
                ...state,
                isgetLoading: true,
                clientConfigData: [],
                getmessage: "",
            };
        },

        onGetClientConfigDataSuccess: (state, { payload }) => {
            const { data = [], message = "", status_code = 200 } = payload;
            return {
                ...state,
                isgetLoading: false,
                clientConfigData: data,
                getmessage: message,
                get_status_code: status_code,
            };
        },

        onGetClientConfigDataError: (state, { payload }) => {
            const { data = [], message = "", status_code = 400 } = payload;
            return {
                ...state,
                clientConfigData: data,
                getmessage: message,
                get_status_code: status_code,
                isgetLoading: false,
            };
        },
        onGetClientConfigDataReset: (state) => {

            return {
                ...state,
                get_status_code: null,
                isgetLoading: false,
            };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getclientConfigDataAsync.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getclientConfigDataAsync.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    clientConfigData: action?.payload?.response,
                    isError: false,
                }
            })
            .addCase(getclientConfigDataAsync.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = action?.message;
            });
    }
});

export const {
    passwordModalChecked,
    passwordModalReset,
    onGetClientConfigData,
    onGetClientConfigDataSuccess,
    onGetClientConfigDataError,
    onGetClientConfigDataReset
} = clientConfigDataSlice.actions;

export default clientConfigDataSlice.reducer;
